const common = {
  positive: "#00FC2A",
  negative: "#FE1040",
  portfolioPositive: "#00FC2A",
  portfolioNegative: "#FE1040",
  coin: 11,
  global: 3,
  details: 11,
};

export const light = {
  main: "#FFFFFF",
  background: "#F2F3F4",
  color: "#333",
  line: "#2550EA",
  bar: "#1AD761",
  percentageBase: "#40417c",
  percentageFill: "#B8B8B8",
  border: "#DCDCDC",
  fontFamily: "sans-serif",
  sideScroll: "#FFFAFA",
  pageNumber: "#2172E5",
  converter: "#2172E5",
  shadow: "#3B8CFF",
  bullet: "#2550EA",
  portfolio: "#2172E5",
  ...common,
  portfolioPositive: "#006E33"
};

export const dark = {
  main: "#191B1F",
  background: "#2C2F36",
  color: "#F2F3F4",
  line: "#00FF5F",
  bar: "#2172E5",
  percentageBase: "#B8B8B8",
  percentageFill: "#2172E5",
  border: "#707070",
  pageNumber: "#2172E5",
  fontFamily: "sans-serif",
  sideScroll: "#202020",
  converter: "#1AD761",
  shadow: "#34F17B",
  bullet: "#2172E5",
  portfolio: "#1AD761",
  ...common,
};

export const midnight = {
  main: "#08161f",
  background: "#40417c",
  color: "#F2F3F4",
  line: "#40417c",
  bar: "#511C51",
  percentageBase: "#134f6c",
  percentageFill: "#40417c",
  border: "#707070",
  pageNumber: "#40417c",
  fontFamily: "sans-serif",
  sideScroll: "#202020",
  converter: "#511C51",
  shadow: "#6B366B",
  bullet: "#40417c",
  portfolio: "#F2F3F4",
  ...common,
  positive: "#006E33",
  negative: "#960400",
  portfolioNegative: "#FF7456",
};

export const forest = {
  main: "#2f3e46",
  background: "#354f52",
  color: "#F2F3F4",
  line: "#52796f",
  bar: "#84a98c",
  percentageBase: "#84a98c",
  percentageFill: "#cad2c5",
  border: "#707070",
  pageNumber: "#cad2c5",
  fontFamily: "sans-serif",
  sideScroll: "#1C3639",
  converter: "#84a98c",
  shadow: "#cad2c5",
  bullet: "#252796f",
  portfolio: "#84a98c",
  ...common,
  portfolioNegative: "#FF7456",
};
